import React from 'react'
import {connect} from 'react-redux'
import {Form, actions,} from 'react-redux-form'
import {Row, Col} from 'react-bootstrap'
import RequiredInput from '../../../common/form/elements/required-input'
import FileUpload from '../../../common/form/elements/file-upload';
import ArrowButton from '../../../common/button-arrow'
import {updateFile} from '../../../../actions/files'

const EditDownloadForm = ({dispatch, file, formValid}) => {

  const onSubmit = (payLoad) => {
    dispatch(actions.submitFields('deep.admin_category', updateFile(file.id, payLoad)));
  };

  return (
    <Form model="deep.admin_files.edit" onSubmit={onSubmit}>
      <Row>
        <Col lg={12}>
          <RequiredInput label="Filename"
                         placeholder="Name"
                         model=".name"
                         controlId="name"/>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <FileUpload label="Replace this File (optional)"/>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ArrowButton color="grey"
                       className="pull-right"
                       disabled={!formValid}>Update</ArrowButton>
        </Col>
      </Row>
    </Form>
  )
};

const mapStateToProps = (state) => {
  return {
    formValid: state.deep.forms.admin_files.edit.$form.valid
  };
};

export default connect(mapStateToProps)(EditDownloadForm);



// WEBPACK FOOTER //
// ./src/components/admin/downloads/edit/download-edit-form.jsx